export default __webpack_public_path__ + "static/media/motorcycle2.2507f34a.png";